import { render } from "./CertificateCopyToCompany.vue?vue&type=template&id=86bfba7e"
import script from "./CertificateCopyToCompany.vue?vue&type=script&lang=js"
export * from "./CertificateCopyToCompany.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__